import { SaveMode } from "./SaveModeEnum";

// The user-facing save-format model: the three distinct outcomes the backend can
// produce. Serialized to the wire as the existing (saveMode, convertEmailToPDF)
// flag pair via saveFormatToFlags — the API contract is unchanged.
export enum SaveFormat {
    // Email stays .eml, attachments/files keep their format.
    Original,
    // Email body converts to PDF; attachments/files keep their format.
    EmailAsPdf,
    // Every convertible file (validSaveAsPdfExtentions, which includes eml)
    // converts to PDF; the rest keep their format.
    EverythingAsPdf
}

export interface SaveFormatFlags {
    saveMode: SaveMode;
    convertEmailToPDF: boolean;
}

export const saveFormatToFlags = (format: SaveFormat): SaveFormatFlags => {
    switch (format) {
        case SaveFormat.EmailAsPdf:
            return { saveMode: SaveMode.Default, convertEmailToPDF: true };
        case SaveFormat.EverythingAsPdf:
            // Both flags on: SaveAsPdf converts every canSaveAsPDF file (the email
            // included, since eml is a convertible extension); convertEmailToPDF
            // additionally covers server paths that only honor the email flag
            // (e.g. the Outlook-REST fallback in EmailGraphService).
            return { saveMode: SaveMode.SaveAsPdf, convertEmailToPDF: true };
        default:
            return { saveMode: SaveMode.Default, convertEmailToPDF: false };
    }
};

// The persisted user setting is still the convertEmailToPDF boolean (phase 1),
// so the default can only express Original / EmailAsPdf. An "Everything as PDF"
// default requires the phase-2 enum column on user + tenant.
export const saveFormatFromSettings = (convertEmailToPDF: boolean | undefined): SaveFormat =>
    convertEmailToPDF === true ? SaveFormat.EmailAsPdf : SaveFormat.Original;
